import { useCustomDialog } from 'components/custom-dialog/custom-dialog.hooks';
import SpreedlyCVVDialogContext from './spreedly-cvv-dialog.context';
import { useState } from 'react';
import SpreedlyCVVDialog from './spreedly-cvv-dialog.component';
import { useRecacheEnabled } from 'components/payment/payment.new.hooks';

const SpreedlyCVVDialogProvider = ({ children, paymentInstrumentId }) => {
  const { open, handleClose, handleOpen } = useCustomDialog();
  const [onSuccessRecacheCallback, setOnSuccessRecacheCallback] =
    useState(null);
  const recacheEnabled = useRecacheEnabled();

  const handleCheckWithCVVRecacheDialogAndDoPayment = async trigger => {
    if (recacheEnabled) {
      setOnSuccessRecacheCallback(() => trigger);
      handleOpen();
    } else await trigger();
  };

  return (
    <SpreedlyCVVDialogContext.Provider
      value={{
        open,
        handleClose,
        onSuccessRecacheCallback,
        paymentInstrumentId,
        handleCheckWithCVVRecacheDialogAndDoPayment,
      }}
    >
      {children}
      <SpreedlyCVVDialog />
    </SpreedlyCVVDialogContext.Provider>
  );
};

export default SpreedlyCVVDialogProvider;
